import script from "./audio.vue?vue&type=script&lang=ts&setup=true"
export * from "./audio.vue?vue&type=script&lang=ts&setup=true"

import "./audio.vue?vue&type=style&index=0&id=76aa2be6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76aa2be6"]])

export default __exports__